export const getFormattedNumber = (value: number) => new Intl.NumberFormat().format(value);

export const getRandomInt = (min: number, max: number) => Math.floor(Math.random() * (max - min + 1)) + min;
